module.exports = __webpack_public_path__ + "static/media/ETH.a85b6de0.png";